import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import MessageContent from './MessageContent'
import { useTranslation } from 'react-i18next';
// import { CircleAlert } from 'lucide-react';

export default function WorkstationNotificationsDrawer(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.closeDrawer()} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Notifications")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <div className={classes.body}>
                <div className={classes.messagesContainer}>
                    {props.notifications.length > 0 && props.notifications.map(z =>
                        <MessageContent message={z} key={z.id}></MessageContent>
                    )}
                </div>
            </div>
            {/* <button className={classes.openDialogButton} onClick={props.openReportProblemDialog}>
                <CircleAlert className={classes.buttonIcon} size={24} />
                {t("Report new problem")}
            </button> */}
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "30%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        display: "inline-block"
    },

    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },

    messagesContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
    },

    messageButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        width: "100%",
        textAlign: "left",
        backgroundColor: "#EFEFEF"
    },

    openDialogButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        height: "40px",
        width: "calc(100% - 48px)",

        padding: "8px",
        paddingRight: "16px",

        border: "none",

        borderRadius: "3px",
        backgroundColor: "#F69127",
        color: "#F8F8F8",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        position: "absolute",
        bottom: "24px",
        left: "24px",

        transition: "background-color 0.3s",

        "&:hover": {
            backgroundColor: "#E76F0F",

            cursor: "pointer",

            transition: "background-color 0.3s",
        },
    },

    buttonIcon: {
        position: "absolute",
        left: "8px",
        top: "50%",
        transform: "translateY(-50%)",
    }



}));